import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProductForm from '../components/ProductForm';
import { useMutateProductHandler } from '../dataHandlers/mutateProductHandler';

export default function ProductCreatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { onSubmit, error, isPending } = useMutateProductHandler({
    onSuccess: () => navigate('/products'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <ProductForm
        onSubmit={(payload) => onSubmit(payload, false)}
        onCancel={() => navigate('/products')}
        initialData={{
          name: '',
          type: 'prepaid',
          description: '',
          is_active: false,
          prices: [],
        }}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
